import React from 'react'
import WelcomeHeader from './WelcomeHeader'
import ConciergeStepList from './ConciergeStepList'
import '../../styles/WelcomeSection/WelcomeSection.scss'

const WelcomeSection = () => {
  return (
        <div className="funnel_panel">
            <WelcomeHeader />
            <ConciergeStepList />
        </div>
  )
}

export default WelcomeSection
